<template>
  <div class="type-selector">
    <h2 class="title">Choisissez votre type de compte</h2>

    <div class="card-container">
      <div
        class="card"
        v-for="option in options"
        :key="option.value"
        @click="$emit('selected', option.value)"
      >
        <h3>{{ option.title }}</h3>
        <p>{{ option.description }}</p>
        <button>Choisir</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserTypeSelector",
  data() {
    return {
      options: [
        {
          value: "therapeute_base",
          title: "Thérapeute (complet)",
          description: "Créer et suivre vos patients, accès à toutes les fonctionnalités.",
        },
        {
          value: "therapeute_sans_patient",
          title: "Thérapeute (activités seulement)",
          description: "Accédez à toutes les ressources et outils sans patient.",
        },
        {
          value: "patient_sans_therapeute_libre",
          title: "Utilisateur autonome",
          description: "Accès à toutes les ressources, sans lien thérapeute.",
        },
        {
          value: "patient_sans_therapeute_recommandation",
          title: "Utilisateur recommandé",
          description: "Accès à un programme spécifique conseillé par un professionnel.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.type-selector {
  text-align: center;
  padding: 40px 20px;
}
.title {
  font-size: 24px;
  margin-bottom: 30px;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}
.card {
  width: 260px;
  padding: 20px;
  background: #f8faff;
  border: 1px solid #cce2ff;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.card:hover {
  transform: scale(1.03);
  border-color: #239380;
}
.card h3 {
  color: #239380;
  margin-bottom: 10px;
}
.card p {
  font-size: 14px;
  color: #555;
  margin-bottom: 16px;
}
.card button {
  background: #239380;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
</style>
